import { Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/Button'
import { Modal, ToastViewport } from '@/components/overlays'
import { useAuth } from '@/features/auth/AuthContext'
import { useToasts } from './toasts'
import { Header } from './Header'
import { Footer } from './Footer'

export function AppLayout() {
  const { t } = useTranslation(['common', 'auth'])
  const { sessionExpired, dismissSessionExpired, signIn } = useAuth()
  const { toasts, dismiss } = useToasts()

  return (
    <div className="flex min-h-screen flex-col">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-sm focus:bg-itpu-teal focus:px-4 focus:py-2 focus:text-white"
      >
        {t('nav.skipToContent')}
      </a>

      <Header />

      <main id="main" className="mx-auto w-full max-w-content flex-1 px-4 py-6">
        <Outlet />
      </main>

      <Footer />

      {/*
        §14 — the session-expired dialog sits over the current screen rather than
        replacing it, so the route and any half-written review survive the
        re-authentication.
      */}
      <Modal
        open={sessionExpired}
        onOpenChange={(open) => {
          if (!open) dismissSessionExpired()
        }}
        title={t('auth:sessionExpiredTitle')}
        footer={
          <>
            <Button variant="ghost" onClick={dismissSessionExpired}>
              {t('action.close')}
            </Button>
            <Button onClick={() => void signIn()}>{t('auth:signInAgain')}</Button>
          </>
        }
      >
        <p className="text-body text-text-muted">{t('auth:sessionExpiredBody')}</p>
      </Modal>

      <ToastViewport toasts={toasts} onDismiss={dismiss} />
    </div>
  )
}
